export const environment = {
    production: false,
    // BETA server settings for API backend
    baseUrlAPI: 'https://myenergy.novitech.sk/api/v1',
    baseUrlDataAPI: 'https://myenergy.novitech.sk/data',
};
